/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import React from 'react';

/**
 * @typedef {import('@salesforce/commerce-sdk-react').ApiClients} ApiClients
 *
 * @typedef {ApiClients['shopperProducts']['getProduct']} GetProduct
 * @typedef {Exclude<Awaited<ReturnType<GetProduct>>, Response>} Product
 *
 * @typedef {ApiClients['shopperSearch']['productSearch']} GetProductSearchResult
 * @typedef {Exclude<Awaited<ReturnType<GetProductSearchResult>>, Response>} ProductSearchResult
 *
 * @typedef {ApiClients['shopperProducts']['getCategory']} GetCategory
 * @typedef {Exclude<Awaited<ReturnType<GetCategory>>, Response>} Category
 *
 * @typedef {ApiClients['shopperStores']['getStores']} GetStores
 * @typedef {Exclude<Awaited<ReturnType<GetStores>>, Response>['data'][0]} Store
 */
export const PageContext = React.createContext({
  /**
   * @type {Contentful.Page}
   */
  page: null,

  /**
   * @type {boolean}
   */
  isDebug: false,

  /**
   * @type {boolean}
   */
  isPreview: false,

  /**
   * @type {boolean}
   */
  isEdit: false,

  /**
   * @type {boolean}
   */
  isProductPage: false,

  /**
   * @type {boolean}
   */
  isCategoryPage: false,

  /**
   * @type {boolean}
   */
  isStorePage: false,


  // ------------------------------------------------------------
  // Product Aspects
  // ------------------------------------------------------------
  /**
   * @type {Product | null}
   */
  product: null,

  /**
   * @type {boolean}
   */
  isProductLoading: false,

  /**
   * @type {boolean}
   */
  isProductError: false,

  /**
   * @type {Error | null}
   */
  productError: null,


  // ------------------------------------------------------------
  // Category Aspects
  // ------------------------------------------------------------
  /**
   * @type {ProductSearchResult | null}
   */
  productSearchResult: null,

  /**
   * @type {boolean}
   */
  isProductSearchLoading: false,

  /**
   * @type {boolean}
   */
  isProductSearchFetched: false,

  /**
   * @type {boolean}
   */
  isProductSearchRefetching: false,

  /**
   * @type {Category | null}
   */
  category: null,

  /**
   * @type {boolean}
   */
  categoryError: null,


  // ------------------------------------------------------------
  // Store Aspects
  // ------------------------------------------------------------
  /**
   * @type {Store | null}
   */
  store: null,

  /**
   * @type {boolean}
   */
  isStoreLoading: false,

  /**
   * @type {boolean}
   */
  isStoreError: false,

  /**
   * @type {Error | null}
   */
  storeError: null,
});
